import { React, useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import choose_image_1 from '../images/liaison/simplicity.png'
import choose_image_2 from '../images/liaison/expertise.png'
import choose_image_3 from '../images/liaison/Visibility.png'
import choose_image_4 from '../images/liaison/save_time.png'
import Button from '../Components/Button';
import FormModal from '../Components/FormModal';

function Whyus() {
      // Modal State & Function
    const [modalToggle, setModalToggle] = useState(false);
    function toggle () {
        setModalToggle(!modalToggle);
    }
    // -------------------

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const chooseus = [
        {
            src: choose_image_1,
            alt: "Simplicity",
            heading: "Simplicity",
            sub_heading: "Eliminate uncertainty",
            content: "Managing all approvals and NOCs through the right channels to keep your project moving.",

        },
        {
            src: choose_image_2,
            alt: "Expertise",
            heading: "Expertise",
            sub_heading: "Diverse capability",
            content: "Deep experience in statutory compliance and liaison across all property types.",

        },
        {
            src: choose_image_3,
            alt: "Visibility",
            heading: "Visibility",
            sub_heading: "Transparency & Trust",
            content: "Transparent updates at every stage so you can make confident decisions.",

        },
        {
            src: choose_image_4,
            alt: "Save Time",
            heading: "Save Time",
            sub_heading: "On Schedule, every time",
            content: "Realistic timelines, delivered on schedule, from start to finish.",

        },
    ]
    return (
        <>
            {/* Why Choose us */}
            <div className="mt-10 pb-[125px] max-w-full mx-auto bg-grey py-[60px]" data-aos="fade-up">
                <h1 className='heading !font-noto'>Why choose us ?</h1>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' />

                <div className="max-w-[1278px] mx-auto flex flex-wrap justify-between gap-y-10 mt-[40px] md:mt-[62px] px-2" data-aos="fade-up">
                    {
                        chooseus.map((items) => {
                            return (

                                <div className='w-[294px] h-[390px] mx-auto bg-white shadow-md py-[40px] sm:pt-[70px]'>
                                    <img className="w-[60px] h-[60px] mx-auto sm:w-[50px] sm:h-[50px]" src={items.src} alt={items.alt} />

                                    <div className='max-w-[225px] mx-auto mt-[35px] text-center'>
                                        <h2 className="text-[26px] font-noto font-bold leading-[40px] ">{items.heading}</h2>
                                        <p className="font-alibaba text-[18px] text-[#5F5D5E] leading-[26px] font-normal mt-[20px]">{items.content}</p>
                                    </div>

                                </div>

                            )
                        })} 
                </div>

                <div className='flex justify-center mt-[85px]' data-aos="fade-up">
                     <Button
                            name={"Work with us"}
                            design={"filled"}
                            action={"modal-open"}
                            modalfunction = {toggle}
                        />
                    {/* <button className="bg-yellow font-alibaba font-bold text-[#191915] w-[230px] h-[54px] text-center py-[13px] text-[16px] leading-[16px] mt-[85px]" data-aos="fade-up" data-aos-duration="700">Work with us</button> */}
                </div>
                

            </div>

            <FormModal modal={modalToggle} active={toggle} />

        </>
    );
}

export default Whyus;